$(function () {
  let token = document.head.querySelector('meta[name="csrf-token"]');

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': token.content
    }
  });
});

// window.globals = {
//     enableImageMagnificPopup: true,
// };
window.globals.enableImageMagnificPopup = true;

$(document).ready(function () {
  window.openMagnificPopup = function (mediaId) {
    if (!globals.enableImageMagnificPopup) {
      return false;
    }

    let items = [];
    $('.free-image-popup').each(function (index) {
      items.push({
        id: $(this).data('mfp-id'),
        src: $(this).data('mfp-src'),
        title: $(this).attr('title'),
      });
    });

    let itemKey = items.findIndex((x) => {
      return x.id === mediaId;
    });

    $.magnificPopup.open({
      type: 'image',
      closeOnContentClick: false,
      closeBtnInside: false,
      items: items,
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.data.title;
        }
      },
      gallery: {
        enabled: true
      },
    }, itemKey);
  };
});


window.errorsToHtml = function (responseJSON) {
  var html = ''
  if (responseJSON.errors) {
    $.each(responseJSON.errors, function (index, group) {
      $.each(group, function (index1, error) {
        html += `<div>${error}</div>`;
      });
    });
  } else {
    return `<div>${responseJSON.message}</div>`;
  }
  return html;
};


/**
 * START - Common functions
 */
$(document).ready(function () {
  const togglers = $('.js-toggle');
  const togglersAction = function () {
    let self = $(this);
    let target = $(self.data('target'));
    let disableTarget = $(self.data('disable-target'));
    let invert = self.data('invert');

    if (invert ? !this.checked : this.checked) {
      target.show();
    } else {
      target.hide();
    }

    if (disableTarget) {
      if (invert ? !this.checked : this.checked) {
        disableTarget.prop('disabled', false);
      } else {
        disableTarget.prop('disabled', true);
      }
    }
  };
  togglers.each(togglersAction);
  togglers.change(togglersAction);


  // $(".js-slider").slider();

  $('input.js-only-digits').on('change blur keyup', function () {
    var regex = /[^0-9\.]+/g;
    this.value = this.value.replace(regex, '');
  })
});

/**
 * END - Common functions
 */
let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
if (isIE) {
  $('.ie-info').show();
}


/**
 * START - Campaign cid
 */

function setCidFromUrlToStorage() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const cid = urlParams.get('cid');
  const eid = urlParams.get('eid');

  if (cid) {
    window.localStorage.setItem('campaign_cid', cid);
    window.localStorage.setItem('campaign_query', urlParams.toString());
  }
  if (eid) {
    window.localStorage.setItem('campaign_eid', eid);
  }
}

setCidFromUrlToStorage();

/**
 * STOP - Campaign cid
 */


/**
 * START - highlight
 * @deprecated  Moved to vue component mixins
 */
function setHighlight() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const highlight = urlParams.get('highlight');

  if (highlight === null) {
    return;
  }

  window.history.replaceState({}, document.title, location.pathname);

  $('body').addClass('has-highlight');
  $(highlight).addClass('element-highlight');

  $('body.has-highlight').click(function () {
    $('body').removeClass('has-highlight');
    $(highlight).removeClass('element-highlight');
  });
}

// $(document).ready(function () {
//     setHighlight();
// });
/**
 * STOP - highlight
 */

